const WORKOUT_SECTIONS_ACTION = {
  ADD_ROUND: 'WORKOUT_SECTIONS_ADD_ROUND',
  DELETE_ROUND: 'WORKOUT_SECTIONS_DELETE_ROUND',
  CREATE: 'WORKOUT_SECTIONS_CREATE',
  COPY: 'WORKOUT_SECTIONS_COPY',
  SAVE: 'WORKOUT_SECTIONS_SAVE',
  UPDATE_CURRENT: 'WORKOUT_SECTIONS_UPDATE_CURRENT',
  DELETE_CURRENT: 'WORKOUT_SECTIONS_DELETE_CURRENT',
  ADD_WORKOUT_EXERCISE: 'WORKOUT_SECTIONS_ADD_WORKOUT_EXERCISE',
  UPDATE: 'WORKOUT_SECTIONS_UPDATE',
  UPDATE_WORKOUT_EXERCISES_ORDER: 'WORKOUT_SECTIONS_UPDATE_WORKOUT_EXERCISES_ORDER',
  DELETE_WORKOUT_EXERCISE: 'WORKOUT_SECTIONS_DELETE_WORKOUT_EXERCISE',
  DELETE: 'WORKOUT_SECTIONS_DELETE',
  CONVERT_TO_STANDARD: 'WORKOUT_SECTIONS_CONVERT_TO_STANDARD',
  CONVERT_TO_CIRCUIT: 'WORKOUT_SECTIONS_CONVERT_TO_CIRCUIT',
  UPDATE_NOTE: 'WORKOUT_SECTIONS_UPDATE_NOTE',
  UPDATE_NAME: 'WORKOUT_SECTIONS_UPDATE_NAME',
  UPDATE_CURRENT_SET_INDEX: 'WORKOUT_SECTIONS_UPDATE_CURRENT_SET_INDEX',
  RESET_CURRENT_SET_INDEX: 'WORKOUT_SECTIONS_RESET_CURRENT_SET_INDEX',
  REORDERING_WORKOUT_EXERCISES: 'WORKOUT_SECTIONS_REORDERING_WORKOUT_EXERCISES',
  RESET_REORDERING_WORKOUT_EXERCISES: 'WORKOUT_SECTIONS_RESET_REORDERING_WORKOUT_EXERCISES'
}

export default WORKOUT_SECTIONS_ACTION
